var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartScreening(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 15.8637L17.0832 14.6137M18.3332 5.86369H1.6665M18.3332 7.53036V4.36369C18.3332 3.43027 18.3332 2.96356 18.1515 2.60704C17.9917 2.29344 17.7368 2.03847 17.4232 1.87868C17.0666 1.69702 16.5999 1.69702 15.6665 1.69702H4.33317C3.39975 1.69702 2.93304 1.69702 2.57652 1.87868C2.26292 2.03847 2.00795 2.29343 1.84816 2.60704C1.6665 2.96356 1.6665 3.43027 1.6665 4.36369V10.697C1.6665 11.6304 1.6665 12.0972 1.84816 12.4537C2.00795 12.7673 2.26292 13.0222 2.57652 13.182C2.93304 13.3637 3.39975 13.3637 4.33317 13.3637H8.74984M17.9165 12.5304C17.9165 14.1412 16.6107 15.447 14.9998 15.447C13.389 15.447 12.0832 14.1412 12.0832 12.5304C12.0832 10.9195 13.389 9.61369 14.9998 9.61369C16.6107 9.61369 17.9165 10.9195 17.9165 12.5304Z",
    stroke: "#1943DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartScreening);
export default __webpack_public_path__ + "static/media/smartScreening.6e85c47cac80a87e2cb1c00678b48430.svg";
export { ForwardRef as ReactComponent };